import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ComboboxOption} from '../../../_models/ComboboxOption';

/**
 * Guscio grafico del filtro a tendina con ricerca: etichetta, trigger e popover con searchbar.
 *
 * È volutamente privo di logica — non sa da dove arrivino le opzioni e non tiene stato proprio:
 * riceve tutto come input e riemette gli eventi originali. Nasce estraendo il markup del
 * combobox di /pesate, che resta il proprietario della propria logica di caricamento, così le
 * schermate che filtrano per valori esistenti (pesate, materiale consumato) restano identiche
 * fra loro senza duplicare markup e stili.
 */
@Component({
  selector: 'app-option-combobox',
  templateUrl: './option-combobox.component.html',
  styleUrls: ['./option-combobox.component.scss'],
  standalone: false
})
export class OptionComboboxComponent {
  @Input() label = '';
  @Input() placeholder = 'Seleziona';
  /** Testo del tooltip ⓘ accanto all'etichetta; assente = nessuna icona. */
  @Input() hint = '';
  @Input() options: ComboboxOption[] = [];
  @Input() selected?: ComboboxOption;
  @Input() loading = false;
  @Input() loadingMore = false;
  @Input() canLoadMore = false;
  @Input() loadError = false;
  @Input() searchText = '';
  @Input() emptyMessage = 'Nessun valore disponibile.';
  @Input() isOpen = false;
  @Input() popoverEvent?: Event;

  @Output() opened = new EventEmitter<Event>();
  @Output() searchInput = new EventEmitter<Event>();
  @Output() optionSelect = new EventEmitter<ComboboxOption>();
  @Output() clearSelection = new EventEmitter<Event>();
  @Output() closed = new EventEmitter<void>();
  @Output() loadNextPage = new EventEmitter<void>();

  onScroll(event: Event): void {
    const content = event.target as HTMLElement;
    const nearBottom = content.scrollTop + content.clientHeight >= content.scrollHeight - 48;
    if (nearBottom && this.canLoadMore && !this.loading && !this.loadingMore) {
      this.loadNextPage.emit();
    }
  }
}
